export default __webpack_public_path__ + "media/images/admin/account-hover-4d80453654e72a1d954bbba38bda9c18.svg";